/**
 * Aura reducer - Daily point stats for composer and feed.
 * Keeps remainingToday in sync when user gives aura (AuraPill, composer).
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dailyStats: null,
};

const auraSlice = createSlice({
  name: 'aura',
  initialState,
  reducers: {
    setDailyStats: (state, action) => {
      state.dailyStats = action.payload;
    },
    decrementRemaining: (state, action) => {
      if (state.dailyStats && state.dailyStats.remainingToday > 0) {
        const amount = Math.max(1, Number(action.payload) || 1);
        state.dailyStats = {
          ...state.dailyStats,
          remainingToday: Math.max(0, state.dailyStats.remainingToday - amount),
          dailySent: (state.dailyStats.dailySent ?? 0) + amount,
        };
      }
    },
  },
});

export const { setDailyStats, decrementRemaining } = auraSlice.actions;
export const selectDailyStats = (state) => state.aura?.dailyStats ?? null;
export default auraSlice.reducer;
